import {useEffect, useRef} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {installAxiosNotFoundRedirect} from '../axiosNotFoundRedirect';

const AxiosNotFoundRedirect = () => {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const pathnameRef = useRef(pathname);

    useEffect(() => {
        pathnameRef.current = pathname;
    }, [pathname]);

    useEffect(() => installAxiosNotFoundRedirect({
        navigate,
        getCurrentPath: () => pathnameRef.current,
    }), [navigate]);

    return null;
};

export default AxiosNotFoundRedirect;
